import { getAccessToken } from '@doda/common/src/services/getAccessToken';
import { IncomingHttpHeaders } from 'http';

/**
 * getAccessToken
 * @param headers
 * @returns accessToken
 */
export const fetchAccessToken = async (
  headers?: IncomingHttpHeaders
): Promise<string | undefined> => {
  try {
    const token = await getAccessToken(headers);
    if (!token) throw new Error('access token was undefined');
    return token;
  } catch (error) {
    window.DD_LOGS?.logger.error(`Failed to get access token, error: ${error}`);
    return undefined;
  }
};
